const parsePercentage = (value) => value.toString().replace(/[^0-9\.]/g, '')

export default parsePercentage



// WEBPACK FOOTER //
// ./src/utils/parsers/parsePercentage.js